import React from "react";
import PropTypes from "prop-types";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import MDButton from "components/MDButton";
import Typography from "@mui/material/Typography";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "auto",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  textAlign: "center",
  overflowY: "auto",
  maxHeight: "80%",
};

function MyModal({ show, onHide, title, body, onSubmit, submitText, colorButtonSubmit }) {
  return (
    <Modal
      open={show}
      onClose={onHide}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Fade in={show}>
        <Box sx={style}>
          <Typography id="modal-title" variant="h6" component="h2">
            {title}
          </Typography>
          <Box id="modal-description" sx={{ mt: 2 }}>
            {body}
          </Box>
          <Box sx={{ mt: 4, display: "flex", justifyContent: "center", gap: 2 }}>
            <MDButton variant="outlined" color="secondary" onClick={onHide}>
              Tutup
            </MDButton>
            {onSubmit && (
              <MDButton variant="outlined" color={colorButtonSubmit} onClick={onSubmit}>
                {submitText || "Submit"}
              </MDButton>
            )}
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}

MyModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.node.isRequired,
  onSubmit: PropTypes.func,
  variant: PropTypes.oneOf(["text", "outlined", "contained"]),
  submitText: PropTypes.string,
  colorButtonSubmit: PropTypes.string,
};

export default MyModal;
